// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Print from 'vue-print-nb'

//import '../static/css/index.css';
Vue.use(ElementUI);
// import Vuex from 'vuex';
// Vue.use(Vuex);
import axios from 'axios';
import CommonUtil from './utils/CommonUtil.js'
import Md5Util from './utils/Md5Util.js'
import ArrayUtil from './utils/ArrayUtil.js'
import StringUtil from './utils/StringUtil.js'
import DateUtil from './utils/DateUtil.js'
import JsonUtil from './utils/JsonUtil.js'
import Base64util from './utils/Base64util.js'
import global_ from './utils/Global.js'
import echarts from 'echarts'
import directives from './utils/Directives.js'
import Printjs from './utils/print.js'

Vue.use(CommonUtil);
Vue.use(Md5Util);
Vue.use(ArrayUtil);
Vue.use(StringUtil);
Vue.use(DateUtil);
Vue.use(JsonUtil);
Vue.use(Base64util);
Vue.use(directives);
Vue.use(Print);
Vue.use(Printjs);
Vue.prototype.GLOBAL = global_;
Vue.prototype.$echarts = echarts;

var millon = new Date().getTime();
var loadingInstance = null;
axios.defaults.baseURL = global_.BASE_URL;
axios.interceptors.request.use(
  config => {
    var token = window.localStorage.getItem(global_.USER_TOKEN);
    millon = parseInt(new Date().getTime()/1000);
    config.headers.Authorization = token;
    var str = Md5Util.md5(global_.NEUQ_SECRET_KEY + '.' + millon) + '.' + millon;
    config.headers['Zxq-Auth'] = str;
    config.headers['Zxq-App'] = "zxq-web";
    // config.headers['Neuq-Platform'] = "neuq-backend";
    loadingInstance = ElementUI.Loading.service({
      text: '拼命加载中...'
    });
    return config;
  }
);
axios.interceptors.response.use(
  response => {
    var status = response.status;
    const data = response.data;
    var msg = data.message;
    if(status === 200){
      if(data.code == '401' || data.code == '403'){
        if(loadingInstance != null){
          loadingInstance.close();
          loadingInstance = null;
        }
        // ElementUI.Message.error({message: '登录已过期，请重新登录'});
        window.localStorage.removeItem(global_.USER_TOKEN);
        window.localStorage.removeItem(global_.SYS_CODE);
        window.localStorage.removeItem(global_.USER_AUTH);
        window.localStorage.removeItem(global_.USER_MENU);
        window.localStorage.removeItem(global_.USER_INFO);
        router.push('/login');
        throw new Error(response);
      }else if(data.code == '500'){
        ElementUI.Message.error({message: '服务器异常，请稍后再试！'});
        if(loadingInstance != null){
          loadingInstance.close();
          loadingInstance = null;
        }
        console.error(response.data)
        throw new Error(response);
      }else if(data.code == '404'){
        ElementUI.Message.error({message: '您访问的地址不存在或被转移！'});
        if(loadingInstance != null){
          loadingInstance.close();
          loadingInstance = null;
        }
        console.error(response.data)
        throw new Error(response);
      }else{
        if(loadingInstance != null){
          loadingInstance.close();
          loadingInstance = null;
        }
        return response.data;
      }
    } else if (status > 399) {
      if(loadingInstance != null){
        loadingInstance.close();
        loadingInstance = null;
      }
      ElementUI.Message.error({message: '服务器异常，请稍后再试！'});
      console.error(response.data)
      throw new Error(response);
    }
  },
  err => {
    if(loadingInstance != null){
      loadingInstance.close();
      loadingInstance = null;
    }
    ElementUI.Message.error({message: '服务器异常，请稍后再试！'});
    console.error(err)
    return Promise.reject(err);
    // if(err.indexOf('401') > -1){
      // window.localStorage.removeItem(global_.USER_TOKEN);
      // window.localStorage.removeItem(global_.SYS_CODE);
      // window.localStorage.removeItem(global_.USER_AUTH);
      // window.localStorage.removeItem(global_.USER_MENU);
      // window.localStorage.removeItem(global_.USER_INFO);
      // router.push('/login');
    // }else{
    //   ElementUI.Message.error({message: '服务器异常，请稍后再试！'});
    // }
    // return Promise.reject(err);
  }
);
Vue.prototype.$axios = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue()
  },
})



// WEBPACK FOOTER //
// ./src/main.js